module.exports = __webpack_public_path__ + "open-sans-latin-800italic.883ba1182db256c0bec8.eot";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-800italic.eot
// module id = ../../../../typeface-open-sans/files/open-sans-latin-800italic.eot
// module chunks = 1 3